module.exports = __webpack_public_path__ + "media/db_pano.8898c970.mp4";